<template>
  <div id="app">
    <div class="top-sticky">
      <blue-background class="top-sticky__bar">
        <page-header
          :condensed="scrolled"
          :links="content.headerLinks"
          :contactUsButton="{
            text: content.sections.titlePage.buttonText,
            link: content.sections.titlePage.buttonLink,
          }"
        ></page-header>
      </blue-background>
    </div>
    <router-view v-slot="{ Component, route }">
      <transition name="page" mode="out-in">
        <div v-if="Component" :key="route.path">
          <component :is="Component" />
        </div>
      </transition>
    </router-view>
    <faded-background :image="'beach_4_1.png'"></faded-background>
    <contact :content="content.sections.contact"></contact>

    <page-footer :links="content.headerLinks"></page-footer>
    <floating-contact
      :contactId="content.sections.contact.id"
      :phone="content.sections.contact.phone"
    ></floating-contact>
  </div>
</template>

<script>
import content from "./content.js";

import Header from "./components/header/Header.vue";
import BlueBackground from "./components/background/BlueBackground.vue";
import FadedBackground from "./components/background/FadedBackground.vue";
import Contact from "./components/section/Contact.vue";
import Footer from "./components/footer/Footer.vue";
import FloatingContact from "./components/util/FloatingContact.vue";

export default {
  name: "app",
  components: {
    "page-header": Header,
    "blue-background": BlueBackground,
    "faded-background": FadedBackground,
    contact: Contact,
    "page-footer": Footer,
    "floating-contact": FloatingContact,
  },
  data() {
    return { content, scrolled: false };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 16;
    },
  },
};
</script>

<style lang="scss">
@import "./global.scss";

// The sticky wrapper keeps the full header height in the page flow, so when
// the bar condenses on scroll the content underneath doesn't jump.
.top-sticky {
  position: sticky;
  top: 0;
  z-index: 1000; /* Keeps it above other content */
  height: $header-height;
  pointer-events: none;
}

.top-sticky__bar {
  pointer-events: auto;
  border-bottom: 1px solid $third;
}

.title-section {
  padding-top: 50px;
  padding-bottom: 50px;
}

.birds {
  height: 200px;
  padding-right: 500px;
  width: auto;
}

@media (min-width: $mobile-break) {
  .title-section {
    padding-top: 100px;
    padding-bottom: 10px;
  }
  .birds {
    height: 200px;
    width: auto;
  }
}
</style>
